import React from 'react';
import { useDispatch } from 'react-redux';

import { redirectToUrl } from '@gumtree/ui-library/src/utils/browser-service';
import { getNonFalsyUrlSearchParams } from '@gumtree/shared/src/util/url-params';

import { formatNumber } from '@gumtree/ui-library/src/utils/string-service';

import { setSingleFilterState, trackGA4FiltersDiffThunk } from '../../../reducers/current-filter-states';
import { updateSearchResultAbundance } from '../../../reducers/search-result-abundance';
import type { Filter, FilterKey } from '../../../types';
import type { SrpUseDispatch } from '../../../reducers';
import {
    StylesLabel,
    StyledToggle,
    StyledToggleFilterContainer,
    StylesQuantityLabelContainer,
} from './style';

interface ToggleFilterProps {
    filterKey: FilterKey;
    isListView?: boolean;
    abundance: number | undefined;
    title: string | undefined;
    currentFilterStates: Filter;
}

const ToggleFilter = ({
    filterKey,
    isListView,
    abundance,
    title,
    currentFilterStates,
}: ToggleFilterProps) => {
    const dispatch = useDispatch() as SrpUseDispatch;

    const onChangeHandler = (event, abundance = 0) => {
        const { checked } = event.target;

        if (isListView) {
            const url = getNonFalsyUrlSearchParams(currentFilterStates);

            url.set(filterKey, checked);
            dispatch(trackGA4FiltersDiffThunk({
                searchFilters: {
                    [filterKey]: checked
                }
            }));
            redirectToUrl(`/search?${url}`);
        } else {
            dispatch(updateSearchResultAbundance(abundance));
            dispatch(setSingleFilterState({ key: filterKey, value: checked }));
        }
    };

    return (
        <StyledToggleFilterContainer>
            <StyledToggle
                checked={currentFilterStates[filterKey] as boolean | undefined}
                id={`toggle-filter-${filterKey}`}
                type="checkbox"
                className="hide-visually"
                onChange={(event) => onChangeHandler(event, abundance)}
            />

            <StylesLabel htmlFor={`toggle-filter-${filterKey}`}>
                {title}
                <StylesQuantityLabelContainer>
                    {formatNumber(abundance)}
                </StylesQuantityLabelContainer>
            </StylesLabel>
        </StyledToggleFilterContainer>
    );
};

export default ToggleFilter;
